import * as Yup from "yup";

const VehicleMakeSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  logo: Yup.string(),
});

export default VehicleMakeSchema;
